import { render, staticRenderFns } from "./HomeWidgets.vue?vue&type=template&id=0361cc04&scoped=true"
import script from "./HomeWidgets.vue?vue&type=script&lang=js"
export * from "./HomeWidgets.vue?vue&type=script&lang=js"
import style0 from "./HomeWidgets.vue?vue&type=style&index=0&id=0361cc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361cc04",
  null
  
)

export default component.exports